import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

/** Passthrough shared by every workflow-run filter field: no margin, label aligned to the field's left edge. */
const formFieldStylesPt = {
	...fieldWithoutMarginStyles,
	label: {
		style: {
			alignSelf: 'flex-start',
			marginLeft: '.5rem',
		},
	},
};

export default formFieldStylesPt;
